import * as React from "react";
import { Outlet, Route, Navigate } from "react-router-dom";
import { AppConfiguration } from "src/common";
import { DeveloperRoutes } from "src/common/developers";
import { Diagnostics, Sandbox, UIGuides, Workflows } from "../components/developer";

function DeveloperPage() {
  return (
    <Outlet />
  );
}

export function DeveloperPageRoutes() {
  // Description: Only allow navigation if this environment is NOT production
  return !AppConfiguration.isDevelopmentRunMode() ?
    <Route path="*" element={<Navigate to="/" replace />} /> :
    <>
      <Route path={""} element={<Navigate to={`${DeveloperRoutes.workflow_route}`} replace />} />
      <Route path={`${DeveloperRoutes.ui_guide_route}/*`} element={<UIGuides />} />
      <Route path={`${DeveloperRoutes.workflow_route}/*`} element={<Workflows />} />
      <Route path={DeveloperRoutes.sandbox_route} element={<Sandbox />} />
      <Route path={`${DeveloperRoutes.diagnostics}/:user_id/:path`} element={<Diagnostics />} />
      <Route path={`${DeveloperRoutes.diagnostics}/:user_id`} element={<Diagnostics />} />
      <Route path={DeveloperRoutes.diagnostics} element={<Diagnostics />} />
    </>;
}

export default React.memo(DeveloperPage);
